import { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'

interface DownloadAppDialogProps {
  isOpen: boolean
  onOpenChange: (open: boolean) => void
  artistName?: string
  isArtist?: boolean
  title?: string
  description?: string
}

export function DownloadAppDialog({
  isOpen,
  onOpenChange,
  artistName,
  isArtist,
  title,
  description
}: DownloadAppDialogProps) {
  const { t } = useTranslation()
  const [mounted, setMounted] = useState(false)
  const appStoreUrl = 'https://apps.apple.com/fi/app/getmoretats/id6754553245'

  const dialogTitle = title || 'We have an app!'

  const defaultDescription = isArtist
    ? 'Download GetMoreTats from the App Store and get notified when clients message you!🤩'
    : artistName
      ? `Download GetMoreTats from the App Store and get notified when ${artistName} replies!🤩`
      : 'Download GetMoreTats to access all features and get the full experience on your phone!🤩'

  const descriptionText = description || defaultDescription

  useEffect(() => {
    setMounted(true)
  }, [])

  if (!mounted || !isOpen) return null

  return (
    <>
      {/* Overlay */}
      <div
        className="fixed inset-0 z-50 bg-black/50 animate-in fade-in-0"
        onClick={() => onOpenChange(false)}
      />

      {/* Modal */}
      <div className="fixed inset-0 z-50 flex items-center justify-center pointer-events-none p-4">
        <div className="bg-background rounded-[var(--card-radius)] shadow-lg max-w-sm w-full animate-in zoom-in-95 pointer-events-auto">
          {/* Content */}
          <div className="p-6 space-y-4 text-center">
            {/* Title */}
            <h2 className="text-xl font-semibold text-foreground">{dialogTitle}</h2>

            {/* Description */}
            <p className="text-base text-foreground leading-relaxed">{descriptionText}</p>

            {/* Button */}
            <a
              href={appStoreUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="block w-full mt-6"
            >
              <button className="w-full bg-primary hover:bg-primary/90 text-primary-foreground font-semibold py-3 rounded-lg transition-colors">
                {t('common.downloadApp', 'Download App')}
              </button>
            </a>
          </div>
        </div>
      </div>
    </>
  )
}

